"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const cast_1 = require("../../../utilites/cast");
const ImageInfo_1 = require("../../basic/ImageInfo");
const FileInfo_1 = require("../../basic/FileInfo");
class AWSource {
    constructor(type) {
        this.url = '';
        this.type = '';
        this.version = '';
        this.local = false;
        this.files = [];
        this.size = 0;
        this.duration = 0;
        this.fps = 0;
        this.thumbnail = null;
        if (type)
            this.type = type;
    }
}
exports.AWSource = AWSource;
AWSource.propFactory = {
    files: (object) => {
        if (typeof object === 'object' && object !== null) {
            const a = Array.isArray(object) ? object : Object.values(object);
            return a.map(item => FileInfo_1.FileInfo.from(item));
        }
    },
    thumbnail: (object) => cast_1.castToType(object, ImageInfo_1.ImageInfo)
};
